import angular from 'angular';
import '../core.module';

function authTokenInterceptorFactory(SessionService) {
  return {
    request(config) {
      if (SessionService.token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${SessionService.token}`;
      }
      return config;
    }
  };
}

authTokenInterceptorFactory.$inject = ['SessionService'];

function configureInterceptor($httpProvider) {
  $httpProvider.interceptors.push('AuthTokenInterceptor');
}

configureInterceptor.$inject = ['$httpProvider'];

angular
  .module('app.core')
  .factory('AuthTokenInterceptor', authTokenInterceptorFactory)
  .config(configureInterceptor);
